import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'username'})

export class UsernamePipe implements PipeTransform {
    transform(value: string) {
        if (!value) {
            return;
        }
        if (value.indexOf('@') === -1) {
            return value;
        }
        return value.substring(0, value.indexOf('@'));
    }
}
